import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { isBrandFeatureEnabled } from "brand/features";

export default function FeatureRoute({ feature, redirectTo = "/veille", children }) {
  if (!isBrandFeatureEnabled(feature)) {
    return <Navigate to={redirectTo} replace />;
  }
  return children;
}

FeatureRoute.propTypes = {
  feature: PropTypes.string.isRequired,
  redirectTo: PropTypes.string,
  children: PropTypes.node,
};
